import { useEffect } from "react";
import styles from "./zaloChatWidget.module.scss";

export default function ZaloChatWidget() {
  useEffect(() => {
    const zaloDiv = document.createElement("div");
    zaloDiv.classList.add("zalo-chat-widget"); 
    zaloDiv.classList.add(styles["custom-zalo-widget"]);

    zaloDiv.setAttribute("data-oaid", "3642541444673478642");
    zaloDiv.setAttribute("data-welcome-message", "Sapo rất vui khi được hỗ trợ bạn!");
    zaloDiv.setAttribute("data-autopopup", "0");
    zaloDiv.setAttribute("data-width", "350");
    zaloDiv.setAttribute("data-height", "420");
    document.body.appendChild(zaloDiv);

    const script = document.createElement("script");
    script.src = "https://sp.zalo.me/plugins/sdk.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(zaloDiv);
      document.body.removeChild(script);
    };
  }, []);

  return null;
}
